module.exports = __webpack_public_path__ + "img/hand-icon.246855cc.svg";